import { Link } from '@mui/material';
import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { DescriptionRow } from 'components';
import { ROUTE_PATH } from 'constants/routes';
import { OrderType } from 'enums';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { filtersUtils } from 'utils';

type Props = {
  orderId: string;
  orderType: OrderType;
  createdAt: string | Date;
};

export const OrderWebhooksLink: React.FC<Props> = ({
  orderId,
  orderType,
  createdAt,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.order_webhooks_link',
  });
  const { t: tCommon } = useTranslation(TranslationNamespace.Common);
  const { isAdmin, isTechOperator } = useUser();

  const webhooksUrl = useMemo(() => {
    const webhooksPath = isAdmin
      ? ROUTE_PATH.ADMIN.WEBHOOKS
      : isTechOperator
      ? ROUTE_PATH.TECH_OPERATOR.WEBHOOKS
      : null;

    const filterKey =
      orderType === OrderType.Payin ? 'orderId' : 'payoutOrderId';
    const filters = filtersUtils.encode(
      JSON.stringify({
        [filterKey]: orderId,
        from: moment(createdAt).toISOString(),
      }),
    );
    return `${webhooksPath}?tab=archive&filters=${filters}`;
  }, [isAdmin, isTechOperator, orderId, orderType, createdAt]);

  return (
    <DescriptionRow
      title={t('title')}
      value={
        <Link
          component={RouterLink}
          to={webhooksUrl}
          variant="body2"
          underline="none"
        >
          {tCommon('buttons.open')}
        </Link>
      }
    />
  );
};
